export enum FATCA_LOADING_KEYS {
  FATCA_USER_DATA = 'fatcaUserData',
  FATCA_TAXATION_OPTIONS = 'fatcaTaxationOptions',
  FATCA_ADDRESS = 'fatcaAddress',
  FATCA_LOADING_ACCESS_TO_REAL_STOCKS_STATUS = 'fatcaLoadingAccessToRealStocksStatus',
  FATCA_TAX_RESIDENCY_PRIMARY_HUB = 'fatcaTaxResidencyPrimaryHub',
  FATCA_MISSING_TIN_REASON_PAGE_VALIDATE_REASONS = 'fatcaMissingTINReasonPageValidateReasons',
  FATCA_MISSING_TIN_REASON_VALIDATE_TEXT_REASONS = 'fatcaMissingTINReasonPageValidateTextReasons',
}

export enum FATCA_PAGES_KEYS {
  FATCA_USER_DATA = 'fatcaUserData',
  FATCA_TAXATION_OPTIONS = 'fatcaTaxationOptions',
  FATCA_TAX_RESIDENCY_PRIMARY_HUB = 'fatcaTaxResidencyPrimaryHub',
  FATCA_FINAL_ALLOWED = 'fatcaFinalAllowed',
  FATCA_FINAL_DISALLOWED = 'fatcaFinalDisallowed',
  FATCA_MISSING_TIN_REASON_PAGE = 'fatcaMissingTINReasonPage',
  FATCA_MISSING_TIN_TEXT_REASON_PAGE = 'fatcaMissingTINTextReasonPage',
}
